import React from 'react';
import { CheckIcon, ChevronRightIcon, ShieldCheckIcon, ClockIcon } from 'lucide-react';
export function Pricing() {
  const features = ['Guía completa paso a paso', 'Estrategias de inserción laboral', 'Herramientas para entrevistas', 'BONUS: 50 preguntas + respuestas', 'BONUS: Test de orientación RRHH', 'BONUS: Mensajes para recruiters'];
  return <section className="py-12 md:py-20 bg-gradient-to-b from-slate-50 to-white" data-id="element-106">
      <div className="max-w-4xl mx-auto px-4" data-id="element-107">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-4" data-id="element-108">
          UNA NUEVA ETAPA PROFESIONAL EMPIEZA ACÁ
        </h2>
        <p className="text-center text-gray-600 mb-12" data-id="element-109">
          Un solo pago. Acceso inmediato. Contenido práctico.
        </p>

        <div id="compra" className="bg-white rounded-2xl shadow-2xl p-8 md:p-12 border-2 border-amber-500" data-id="element-110">
          <h3 className="text-2xl md:text-3xl font-bold text-[#1a365d] text-center mb-8" data-id="element-111">
            DE PSICÓLOGO A RRHH
          </h3>

          <div className="space-y-3 mb-8" data-id="element-112">
            {features.map((feature, index) => <div key={index} className="flex items-center gap-3" data-id="element-113">
                <CheckIcon className="w-5 h-5 text-green-500 flex-shrink-0" data-id="element-114" />
                <span className="text-gray-700" data-id="element-115">{feature}</span>
              </div>)}
          </div>

          <div className="text-center mb-8" data-id="element-116">
            <div className="mb-3" data-id="element-117">
              <span className="text-gray-500 line-through text-2xl" data-id="element-118">
                $49.990 ARS
              </span>
            </div>
            <div className="text-5xl md:text-6xl font-bold text-[#1a365d] mb-2" data-id="element-119">
              $19.990 ARS
            </div>
            <p className="text-gray-600" data-id="element-120">Pago único · Sin cargos ocultos</p>
          </div>

          <a href="https://checkout.sectordigital.online/cart/43992952078379:1" className="block w-full bg-amber-500 hover:bg-amber-600 text-white font-bold py-5 px-8 rounded-lg text-xl transition-all transform hover:scale-105 shadow-lg text-center mb-6" data-id="element-121">
            <span className="flex items-center justify-center gap-2" data-id="element-122">
              ACCEDER AHORA
              <ChevronRightIcon className="w-6 h-6" data-id="element-123" />
            </span>
          </a>

          <div className="flex items-center justify-center gap-8 text-sm text-gray-600" data-id="element-124">
            <div className="flex items-center gap-2" data-id="element-125">
              <ClockIcon className="w-5 h-5" data-id="element-126" />
              <span data-id="element-127">Acceso inmediato</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-128">
              <ShieldCheckIcon className="w-5 h-5" data-id="element-129" />
              <span data-id="element-130">Garantía 7 días</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}